const GroupDescription = ({ group }) => (
  <div className="group-desc">
    <pre>{group.description}</pre>
  </div>
);

export default GroupDescription;
